import ManageAccessPanel from 'asset-actions-lib/components/modals/ManageAccessPanel';
import { ACTION_IDS } from 'asset-actions-lib/constants/actionIds';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const MANAGE_ACCESS_ACTION = {
  id: ACTION_IDS.MANAGE_ACCESS,
  name: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "assetActionsLib.sharedActions.manageAccess"
  }),
  onConfirm: () => {},
  ModalOrPanel: ManageAccessPanel,
  actionGroup: 1
};